import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { HotelImageList } from "@/features/hotels/components/hotel/HotelImageList";
import { useHotelOffersContext } from "@/features/hotels/contexts/HotelOffersContext";

export const Route = createFileRoute(
  "/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images",
)({
  component: RouteComponent,
  staticData: {
    drawer: false,
  },
});

function RouteComponent() {
  const intl = useIntl();
  const { roomToken } = Route.useParams();
  const navigate = Route.useNavigate();
  const { data: offers } = useHotelOffersContext();

  const room = offers
    .flatMap((offer) => offer.rooms.flatMap((room) => room.options))
    .find((option) => option.roomToken === roomToken);

  if (!room) {
    return <Navigate to="../.." from={Route.fullPath} />;
  }

  return (
    <div className="px-main">
      <h2 className="mb-4 text-lg font-medium text-text-title">
        {intl.formatMessage({
          defaultMessage: "Photo gallery",
          description: "Label for the photo gallery section",
        })}
      </h2>
      <HotelImageList
        images={room.images || []}
        onImageClick={(index) =>
          navigate({ to: "./fullscreen", search: { index } })
        }
      />
    </div>
  );
}
